import { Prova } from './prova';

export class Disciplina {
  id: string;
  name: string;
  curso: string;
  provas: Prova[];
  constructor() {}
}
